import { render, staticRenderFns } from "./students_collection.vue?vue&type=template&id=2f40efb5&"
import script from "./students_collection.vue?vue&type=script&lang=js&"
export * from "./students_collection.vue?vue&type=script&lang=js&"
import style0 from "./students_collection.vue?vue&type=style&index=0&id=2f40efb5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports